// NOTE: This file should not be edited
// see @configs/tsup for implementation.
// - https://esbuild.github.io/content-types/#auto-import-for-jsx
// - https://github.com/egoist/tsup/issues/390#issuecomment-933488738

import * as React from 'react';

export { React };
